import React from "react";
import AddAndUpdateBatch from "./AddAndUpdateBatch";

const UpdateBatch = () => {
  // console.log(endDate);
  return <AddAndUpdateBatch isUpdate={true} />;
};

export default UpdateBatch;
